
// src/web/components/user-agent.js

export default function () {
  var userAgent = window.navigator.userAgent.toLowerCase();
  
  if (userAgent.indexOf('opera') != -1) {
    return 'opera';
  } else if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1 || userAgent.indexOf('edge') != -1) {
    return 'ie';
  } else if (userAgent.indexOf('chrome') != -1) {
    return 'chrome';
  } else if (userAgent.indexOf('iphone') != -1 || userAgent.indexOf('ipad') != -1) {
    return 'ios-app';
  } else if (userAgent.indexOf('safari') != -1) {
    return 'safari';
  } else if (userAgent.indexOf('firefox') != -1) {
    return 'firefox';
  } else if (userAgent.indexOf('gecko') != -1) {
    return 'gecko';
  } else {
    return false;
  }
}
  


// WEBPACK FOOTER //
// ./src/web/components/user-agent.js